var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17.14,
    viewBox: "0 0 16 17.14",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.53 0h-3.274l-4.256 4.256 4.256 4.256h3.274l-3.174-3.174 5.558.126a4.816 4.816 0 0 1 3.966 4.208c.057 4.688-4.269 5.214-3.966 5.322.078.028-9.914 0-9.914 0v2.14s9.929.012 9.914 0a6.891 6.891 0 0 0 6.086-7.234c-.18-5.691-6.086-6.728-6.086-6.728h-5.556z",
    fill: "#081f2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.c73e2749c7fd2a04d4507ac1853f373c.svg";
export { ForwardRef as ReactComponent };